import RequestCreator from './BaseRequest';

export interface LiberadoResponse {
  match: boolean;
}

class Liberado extends RequestCreator<any, LiberadoResponse> {}

const api = new Liberado('/liberado');
export default api;
